module.exports = "/assets/images/skin.png?e3f799c6dec9af194c86decdf7392405";